import React, { Component, PropTypes } from 'react';
import { Link } from 'react-router';
import { casesRoute } from '../../../routes';

import ContentBlock from '../block/content';
import Splitter from '../block/splitter';

import Carousel from '../../carousel/carousel';
import Image from '../../image/image';
import { Player, PlayerTrigger } from '../../video/player';

import {
	DEVICE_DESKTOP,
	DEVICE_TABLET_PORTRAIT,
	DEVICE_TABLET_LANDSCAPE,
	DEVICE_MOBILE_PORTRAIT,
	DEVICE_MOBILE_LANDSCAPE,
} from '../../../constants/types';

import { dispatchMsg, dispatchError } from '../../../actions/errors';

export default class JuryEntry extends Component {
	static propTypes = {
		item: PropTypes.object.isRequired,
		browser: PropTypes.object.isRequired,
		dispatch: PropTypes.func.isRequired,
		component: PropTypes.oneOfType([
			PropTypes.func,
			PropTypes.oneOf([false]),
		]).isRequired,
		onChangeVote: PropTypes.func.isRequired,
		path: PropTypes.oneOfType([
			PropTypes.string,
			PropTypes.oneOf([false]),
		]).isRequired,
		onSubmit: PropTypes.oneOfType([
			PropTypes.func.isRequired,
			PropTypes.oneOf([false]),
		]).isRequired,
		hideAfterSubmit: PropTypes.bool.isRequired,
		data: PropTypes.oneOfType([
			PropTypes.object,
			PropTypes.oneOf([false]),
		]),
	};

	static defaultProps = {
		hideAfterSubmit: false,
		selected: false,
		path: false,
		onSubmit: false,
		onChangeVote: function() {},
	};

	constructor(props) {
		super();

		this.mounted = true;

		this.state = {
			voteSubmitted: false,
			showWarning: false,
			notBroken: false,
			showVideo: false,
		};
	}

	componentWillUnmount() {
		this.mounted = false;
	}

	render() {
		let VotingComponent = this.props.component;
		let className = 'account-jury__entry';
		let item = this.props.item;
		let imgSpan = { desktop: 'span4', tablet: 'span5', mobile: 'span12' };
		let caseTypes = item.caseTypes ? item.caseTypes : 'Uncategorized';

		let entryHolderClass = 'account-jury__entry-holder';
		if (this.props.hideAfterSubmit && this.state.voteSubmitted) {
			entryHolderClass += ' account-jury__entry-holder--hide';
		}

		let bestViewedWarning = '';
		switch (this.props.item.bestViewedOn) {
			case DEVICE_TABLET_PORTRAIT:
			case DEVICE_TABLET_LANDSCAPE:
				bestViewedWarning = <span>Should be viewed on <strong>tablet</strong> before voting</span>;
				break;
			case DEVICE_MOBILE_PORTRAIT:
			case DEVICE_MOBILE_LANDSCAPE:
				bestViewedWarning = <span>Should be viewed on <strong>mobile</strong> before voting</span>;
				break;
		}

		let slides = [];
		(!!item.slide1) && slides.push(<Image key='slide1' img={item.slide1} span={imgSpan} alt='' browser={this.props.browser} />);
		(!!item.slide2) && slides.push(<Image key='slide2' img={item.slide2} span={imgSpan} alt='' browser={this.props.browser} />);
		(!!item.slide3) && slides.push(<Image key='slide3' img={item.slide3} span={imgSpan} alt='' browser={this.props.browser} />);

		(!!item.showreelUrl) && slides.push(
			<PlayerTrigger key='slide4' url={item.showreelUrl} codaClass='slide-coda__item--is-video' skipSlide onClick={(e) => {
				this.setState({
					...this.state,
					showVideo: !this.state.showVideo,
				});
			}} />
		);

		return (
			<div className={entryHolderClass}>
				<div className={className} >
					<div className='span5 span6-tablet span14-mobile account-jury__entry__col1 account-jury__entry__carousel'>
						<Carousel autoplay={false} sliderClass='span4 span5-tablet span12-mobile pixel-pattern pixel-pattern--dark' sliderListClass='span4 span5-tablet span12-mobile'>
							{slides}
						</Carousel>

						<div className='account-jury__entry__carousel__overlay span4 span5-tablet span12-mobile'>
							<div className='account-jury__entry__carousel__overlay__aligner'>
								<Link to={casesRoute(item.slug)} className='button button--dark-to-light-anim'>See Case</Link>
								<a href={item.url} target='_blank' className='button button--light-to-dark-anim'>Launch Project</a>
							</div>
						</div>

						{(!!item.showreelUrl) && (
							<Player browser={this.props.browser} url={item.showreelUrl} showVideo={this.state.showVideo} onClose={() => { this.setState({ ...this.state, showVideo: false }); }} />
						)}

					</div>

					<div className='span8-tablet span14-mobile account-jury__entry__col2'>
						<div className='account-jury__entry__description'>
							<span className='account-jury__entry__description__cat'>
								{caseTypes.name}
								<span className='account-jury__entry__description__cat__devicewarn'>{bestViewedWarning}</span>
							</span>
							<div className='account-jury__entry__description__content'>
								<h2 className='account-jury__entry__description__content__title'>{item.title}</h2>
								<p className='account-jury__entry__description__content__excerpt'>{item.description}</p>
							</div>
						</div>
					</div>

					{(VotingComponent) && (
						<VotingComponent
							item={item}
							path={this.props.path}
							selected={this.props.selected}
							browser={this.props.browser}
							onSubmit={this.onSubmit.bind(this)}
							onChangeVote={this.onChangeVote.bind(this)}
							data={this.props.data}
							waiting={this.props.waiting}
						/>
					)}

				</div>

				<Splitter />
			</div>
		);
	}

	onSubmit(promise) {
		promise.then((res) => {
			(res.data && res.data.message) && this.props.dispatch(dispatchMsg(res.data));

			this.mounted && this.setState({
				...this.state,
				voteSubmitted: true,
			});

			this.props.onSubmit && this.props.onSubmit(res);

			if (this.props.hideAfterSubmit && this.props.removeItemCB) {
				setTimeout(() => {
					this.props.removeItemCB(this.props.item);
				}, 500);
			}

		}).catch((res) => {
			(res.data && res.data.message) && this.props.dispatch(dispatchError(res.data));
		});
	}

	onChangeVote(val) {
		return this.props.onChangeVote(val);
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/components/account/jury/juryEntry.js
 **/